import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { Waypoint } from 'react-waypoint';
import Scroll from 'react-scroll'
import { Link } from "react-router-dom";
import './index.scss';

// Utils
import chartCapture from '../../utils/Shared/chartCapture';
import CustomRadio from '../../utils/CustomRadio';
import CustomDropdown from '../../utils/CustomDropdown';

// methods
import gaTracking from '../../utils/Shared/gaTracking';
import { loginRedirect, downloadTrigger, urlPushState } from '../../utils/Shared/methods';

// Resources
import AnalysisEarthquakeSurveyPercentPic01 from "../../../images/AnalysisEarthquakeSurvey/mainpic.jpg";

const waypointOption = {
	topOffset: '30%',
	bottomOffset: '30%',
}

class AnalysisEarthquakeSurveyIndex extends Component {
	constructor(params) {
		super(params);
		this.state = {
			articleItems: null,
			nowCategoryID: 0,
			scrollSpyItems: [
				{
					name: 'content02',
					title: '（趴、掩、穩）不敵黃金三角 ',
					show: false,
				},
				{
					name: 'content03',
					title: '臺南調查的民眾反應不及！花蓮調查的民眾老神在在！',
					show: false,
				},
				{
					name: 'content04',
					title: '臺南調查的民眾震後去避難比率低，約花蓮調查的一半',
					show: false,
				},
				,
				{
					name: 'content05',
					title: '花蓮調查的民眾較高比率會準備防災包',
					show: false,
				},
				,
				{
					name: 'content06',
					title: '花蓮調查的民眾八成不保地震險，臺南調查有五成無意願投保',
					show: false,
				},
			],
			valueType: [
				{
					name: 'pdf0'
				},
				{
					name: 'pdf1'
				},
				{
					name: 'pdf2'
				},
				{
					name: 'pdf3'
				},
				{
					name: 'pdf4'
				},
				{
					name: 'pdf5'
				}
			]
		};
	}
	

	componentDidMount() {
		window.scrollTo(0, 0);
		this.props.onLoadHeaderColor('GREEN');
		this.props.onLoadHeaderTheme('DARK');
		this.props.onLoadShowLanguage('HIDE');

		const breadcrumb = [
			{ name: '首頁', href: '/' },
			{ name: '臺南地震 VS 花蓮地震 震後調查比一比', href: '/statistics/AnalysisEarthquakeSurvey' },
		]
		this.props.onLoadShowBreadcrumb('SHOW', breadcrumb);
		
		//檢查登入
		this.checkMemberLogin();
	}
	//檢查登入
	checkMemberLogin = () => {
		if (window.localStorage.getItem('user-token')) {
		this.setState({ isMemberLogin: true });
		}
	}
	
	handleClickRidio(e) {
		let num    = e.currentTarget.dataset.num;
		let group = e.currentTarget.dataset.group;
		let valueType = this.state.valueType;

		valueType[num].name = group;
		// console.log(num)
		// console.log(group)
		this.setState({
			valueType: valueType,
		})
	}
	handleWaypointEnter = (name) => {
		const { scrollSpyItems } = this.state;

		scrollSpyItems.forEach((item) => {
			item.show = false;
			if (name === item.name) {
				item.show = true;
			}
		});

		this.setState({
			scrollSpyItems: scrollSpyItems,
		});

	}

	render() {
		const { isMemberLogin } = this.state;
		const { scrollSpyItems, valueType } = this.state;
	
		return (
			
<div className="AnalysisEarthquakeSurvey" id="home">
	<Helmet>
		<title>0206臺南地震 VS 花蓮地震 震後調查比一比</title>
	</Helmet>
	<div className="scroll-spy">
		{
			scrollSpyItems &&
			scrollSpyItems.map((item, index) => {
				return (
					<div key={index}
						className={"item " + item.name + (item.show ? " -show" : "")}
						onClick={() => { Scroll.scroller.scrollTo(item.name, { smooth: true }) }}>
						<span>{item.title}</span>
					</div>
				)
			})
		}
	</div>

	<div className="scroll-up">
		<a href="#home" className="pc"> <img src={require("../../../images/AnalysisEarthquakeSurvey/Union.svg")}/> </a>
		<a href="#menu" className="mobile"> <img src={require("../../../images/AnalysisEarthquakeSurvey/Union_ph.svg")}/> </a>
	</div>

	<div className="header">


	
		<div className="mass"></div>
		
		<ul className="slideshow">
			<li><span>Slide One</span> </li>
			<li> <span>Slide Two</span> </li>
		</ul>
	</div>

	<section id="content01">
		<div className="container-c c640">
			<div className="infon">
				<p>在2016年與2018年的2月6日，分別發生規模 6.6 地震（震央在高雄美濃）與規模 6.4 地震（震央在花蓮市），這兩起地震有日期上很巧合，地震規模相似，同時也造成建物倒塌或毀損、人命傷亡嚴重。 但兩處居民面對地震的反應跟平時的減災是否也類似呢？國家災害防救科技中心分別於兩次地震發生後半年左右，分別針對震度六級與五級以上的地區，進行電訪調查，藉此探討民眾面臨地震災害的：</p>
				<p>
					1.面臨地震當下的保命策略< br/>
					2.地震當下的第一時間反應< br/>
					3.震後去空曠處地避難情況< br/>
					4.防災包準備情況< br/>
					5.投保地震險概況 < br/>
					以下是我們的比較結果，請看...
				</p>
			</div>
			
		</div>
	
		<div className="container-c c640" id="menu">
			<div className="btn-g">
				<a href="#content02" className="btn">
				趴、掩、穩不敵黃金三角
				</a>
				<a href="#content03" className="btn"> 
				臺南調查的民眾反應不及！花蓮調查的民眾老神在在！
				</a>
				<a href="#content04" className="btn">
				臺南調查的民眾震後去避難比率低，約花蓮調查的一半
				</a>
				<a href="#content05" className="btn">
				花蓮調查的民眾較高比率會準備防災包
				</a>
				<a href="#content06" className="btn">
				花蓮調查的民眾八成不保地震險，臺南調查有五成無意願投保
				</a>
			</div>
		</div>
	</section>

	<hr></hr>

	<section id="content02">
		<div className="container-c c640">
		
			<div className="infon">
				<div className="title">
					<h2>趴、掩、穩< br/>不敵黃金三角</h2>
				</div>
				<p>2016年0206地震時，臺南調查將近有六成認為在地震的時候要靠黃金三角保命，另在2018年的0206花蓮調查中也顯示將近五成民眾也選擇黃金三角。在這兩起地震調查中，認為靠「趴下、掩護、穩住」較適當的民眾，都僅約三成。另外要擔心的是花蓮調查中，不知道地震時該怎麼做的人有兩成，而臺南調查中則是一成不知道該如何做。</p>
				<p>值得注意的是，目前政府宣導的臨震行為中，強調民眾遇到地震時，要放低重心、掩護自身並保護頭頸部、盡量於地震時穩住自己，也就是採取「趴下、掩護、穩住」才是較妥當的臨震保命行為喔！</p>
			</div>
		</div>

		<div className="container-c c640">
			<div className="infon">
				<div className="title">
					<h4>民眾相信的臨震保命策略</h4>
				</div>

				<div className="chart-block">
					<div className="option chart-option">

						<div className="radiobar">
							<CustomRadio className="radio" color="green" 
								group="pdf0" 
								num="0"
								
								checked={ this.state.valueType[0].name === 'pdf0' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-text">圖表</span>
								
							</CustomRadio>
							<CustomRadio className="radio" color="green" 
								group="Statistical0" 
								num="0"
								
								checked={this.state.valueType[0].name === 'Statistical0' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-tex">數據</span>
								
							</CustomRadio>
							{/* {this.state.valueType[0].name} */}
						</div>
						<div className="custom-dropdown download">
							<CustomDropdown title="下載">
							<li><Link to={"/admin/upload/0206survey/比較網頁/民眾相信的臨震保命策略.png"} target="_blank" onClick={() => gaTracking('台南花蓮 震後調查大解析', '01民眾相信的臨震保命策略', '圖表下載')} download>下載PNG</Link> </li>
							<li><Link to={"/admin/upload/0206survey/比較網頁/民眾之臨震反應.xlsx"} target="_blank" onClick={() => gaTracking('台南花蓮 震後調查大解析', '01民眾相信的臨震保命策略', '原始數據下載')} download>下載EXCEL</Link></li>
							</CustomDropdown>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className="container-c c640">

			<div className={`${(valueType[0].name === 'pdf0' || valueType === null ? ' -active' : '')} statistics-charts chat01`}>
				<img src={require("../../../images/AnalysisEarthquakeSurvey/chat01.png")} width="100%"/>
			</div>
			<div className={`${(valueType[0].name === 'Statistical0' ? ' -active' : '')} statistics-datatable2`}>
			
				<table>
		<tbody>
			
			<tr>
				<td colspan="5" rowspan="1">
					<p align="center">民眾相信的臨震保命策略</p>
				</td>
			</tr>
			<tr>
				<td colspan="1" rowspan="2">
					<div>項目</div>
				</td>
				<td colspan="2" rowspan="1" align="center">臺南</td>
				<td colspan="2" rowspan="1" align="center">花蓮</td>
			</tr>
			
			<tr>
				<td><p align="right">次數分配</p></td>
				<td><p align="right">百分比</p></td>
				<td><p align="right">次數分配</p></td>
				<td><p align="right">百分比</p></td>
			</tr>
			<tr>
				<td><p>趴下、掩護、穩住</p></td>
				<td><p align="right">568</p></td>
				<td><p align="right">26.9%</p></td>
				<td><p align="right">530</p></td>
				<td><p align="right">25.9%</p></td>
			</tr>
			<tr>
				<td><p>躲在黃金三角</p></td>
				<td><p align="right">1,202</p></td>
				<td><p align="right">57.0%</p></td>
				<td><p align="right">996</p></td>
				<td><p align="right">48.6%</p></td>
			</tr>
			<tr>
				<td><p>以上皆對</p></td>
				<td><p align="right">27</p></td>
				<td><p align="right">1.3%</p></td>
				<td><p align="right">39</p></td>
				<td><p align="right">1.9%</p></td>
			</tr>
			<tr>
				<td><p>以上皆錯</p></td>
				<td><p align="right">51</p></td>
				<td><p align="right">2.4%</p></td>
				<td><p align="right">30</p></td>
				<td><p align="right">1.5%</p></td>
			</tr>
			<tr>
				<td><p>不知道/很難說（含拒答）</p></td>
				<td><p align="right">262</p></td>
				<td><p align="right">12.4%</p></td>
				<td><p align="right">453</p></td>
				<td><p align="right">22.1%</p></td>
			</tr>
			<tr>
				<td><p>總計</p></td>
				<td><p align="right">2,109</p></td>
				<td><p align="right">100%</p></td>
				<td><p align="right">2,049</p></td>
				<td><p align="right">100%</p></td>
			</tr>

		</tbody>
				</table>
				<p className="table-note">註：依母體比率進行加權，四捨五入至整數，可能產生數值誤差，如想取得調查原始數據可至0206地震網頁下方資料來源申請。</p>
			
			</div>

		</div>
		
	</section>	

	<hr></hr>

	<section id="content03">
		<div className="container-c c640">
			
			<div className="infon">
				<div className="title">
					<h2>臺南調查的民眾反應不及！< br/>花蓮調查的民眾老神在在！</h2>
				</div>
				<p>兩個調查結果顯示， 0206臺南地震調查，有最多（29.8%）的人不動作，細分原因有最多的比率（16%）是來不及反應；而花蓮地震調查顯示民眾在面臨地震當下是老神在在，將近五成並不會有特別反應（未有任何動作），再細分原因，最多的比率（37%）覺得不需要做應變。兩個調查可突顯出花蓮調查的民眾相較臺南調查的民眾對地震比較習以為常。</p>
				<p>另外也發現，臺南調查的民眾除了不動作外，次之則是選擇類似（趴、掩、穩）的行動（15.4%）。反觀花蓮調查，結果顯示有兩成民眾會往外跑，而做（趴、掩、穩）行動的比率卻僅是臺南調查的一半不到（7.3%）。</p>
			</div>
		</div>

		<div className="container-c c640">
			
			<div className="infon">
				<div className="title">
					<h4>民眾之臨震反應</h4>
				</div>
				<div className="chart-block">
					<div className="option chart-option">

						<div className="radiobar">
							<CustomRadio className="radio" color="green" 
								group="pdf1" 
								num="1"
								
								checked={ this.state.valueType[1].name === 'pdf1' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-text">圖表</span>
								
							</CustomRadio>
							<CustomRadio className="radio" color="green" 
								group="Statistical1" 
								num="1"
								
								checked={this.state.valueType[1].name === 'Statistical1' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-tex">數據</span>
								
							</CustomRadio>
							{/* {this.state.valueType[1].name} */}
						</div>
						<div className="custom-dropdown download">
							<CustomDropdown title="下載">
							<li><Link to={"/admin/upload/0206survey/比較網頁/民眾之臨震反應.png"} target="_blank" onClick={() => gaTracking('台南花蓮 震後調查大解析', '02 民眾之臨震反應', '圖表下載')} download>下載PNG</Link></li>
							<li><Link to={"/admin/upload/0206survey/比較網頁/民眾之臨震反應.xlsx"} target="_blank" onClick={() => gaTracking('台南花蓮 震後調查大解析', '02 民眾之臨震反應', '原始數據下載')} download>下載EXCEL</Link></li> 
							</CustomDropdown>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		<div className="container-c c640">
			<div className={`${(valueType[1].name === 'pdf1' || valueType === null ? ' -active' : '')} statistics-charts chat02`}>
				<img src={require("../../../images/AnalysisEarthquakeSurvey/chat02.png")} width="100%"/>
			</div>
			<div className={`${(valueType[1].name === 'Statistical1' ? ' -active' : '')} statistics-datatable2`}>
			
				<table>
					<tbody>
						<tr>
							<td colSpan="5" valign="bottom">
								<p align="center">民眾之臨震反應</p>
							</td>
						</tr>
						
						<tr>
							<td colspan="1" rowspan="2">
								<div>項目</div>
							</td>
							<td colspan="2" rowspan="1" align="center">臺南</td>
							<td colspan="2" rowspan="1" align="center">花蓮</td>
						</tr>
						<tr>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
						</tr>
						<tr>
							<td><p>未有任何動作</p></td>
							<td><p align="right">628</p></td>
							<td><p align="right">29.8%</p></td>
							<td><p align="right">975</p></td>
							<td><p align="right">47.6%</p></td>
						</tr>
						<tr>
							<td><p>往建築物外跑</p></td>
							<td><p align="right">311</p></td>
							<td><p align="right">14.7%</p></td>
							<td><p align="right">414</p></td>
							<td><p align="right">20.2%</p></td>
						</tr>
						<tr>
							<td><p>其他</p></td>
							<td><p align="right">100</p></td>
							<td><p align="right">4.8%</p></td>
							<td><p align="right">234</p></td>
							<td><p align="right">11.4%</p></td>
						</tr>
						<tr>
							<td><p>（趴、掩、穩）相近行動</p></td>
							<td><p align="right">324</p></td>
							<td><p align="right">15.4%</p></td>
							<td><p align="right">150</p></td>
							<td><p align="right">7.3%</p></td>
						</tr>
						<tr>
							<td><p>把門打開，避免出入口損壞</p></td>
							<td><p align="right">250</p></td>
							<td><p align="right">11.8%</p></td>
							<td><p align="right">120</p></td>
							<td><p align="right">5.9%</p></td>
						</tr>
						<tr>
							<td><p>躲在堅固家具旁</p></td>
							<td><p align="right">105</p></td>
							<td><p align="right">5.0%</p></td>
							<td><p align="right">74</p></td>
							<td><p align="right">3.6%</p></td>
						</tr>
						<tr>
							<td><p>找家人</p></td>
							<td><p align="right">279</p></td>
							<td><p align="right">13.2%</p></td>
							<td><p align="right">57</p></td>
							<td><p align="right">2.8%</p></td>
						</tr>
						<tr>
							<td><p>躲在床旁邊</p></td>
							<td><p align="right">112</p></td>
							<td><p align="right">5.3%</p></td>
							<td><p align="right">24</p></td>
							<td><p align="right">1.2%</p></td>
						</tr>
						<tr>
							<td><p>總計</p></td>
							<td><p align="right">2109</p></td>
							<td><p align="right">100%</p></td>
							<td><p align="right">2049</p></td>
							<td><p align="right">100.0%</p></td>
						</tr>
						
						
						
							
					</tbody>
				</table>
				<p className="table-note">註：依母體比率進行加權，四捨五入至整數，可能產生數值誤差，如想取得調查原始數據可至0206地震網頁下方資料來源申請。</p>

				
			</div>
		</div>
	</section>

	<hr></hr>

	<section id="content04">
		<div className="container-c c640">
			<div className="infon">
				<div className="title">
					<h2>臺南調查的民眾震後去避難比率低，<br />約花蓮調查的一半</h2>
				</div>
				<p>調查顯示地震過後，臺南調查的民眾有13.3%會出去空曠處避難，花蓮調查的民眾有24.4％，臺南調查去空曠處避難的比率約花蓮調查的一半。細想兩個地震發生時間，0206臺南地震的發生時間在凌晨四點左右，民眾在睡夢中驚醒，至空曠處避難意願較低。而花蓮地震在晚間12點左右，部分民眾並未就寢，較會去外面避難。此外，出去空曠處避難的民眾中，臺南調查中僅有8.6%會去政府公告的地點，花蓮調查中有13.1％到政府公告避難的地點。</p>
			</div>
		</div>
		<div className="container-c c640">
			<div className="infon">
				<div className="title">
					<h4>是否有去空曠處避難</h4>
				</div>
			</div>
			<div className="chart-block">
					<div className="option chart-option">

						<div className="radiobar">
							<CustomRadio className="radio" color="green" 
								group="pdf2" 
								num="2"
								
								checked={ this.state.valueType[2].name === 'pdf2' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-text">圖表</span>
								
							</CustomRadio>
							<CustomRadio className="radio" color="green" 
								group="Statistical2" 
								num="2"
								
								checked={this.state.valueType[2].name === 'Statistical2' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-tex">數據</span>
								
							</CustomRadio>
							{/* {this.state.valueType[2].name} */}
						</div>
						<div className="custom-dropdown download">
							<CustomDropdown title="下載">
							<li><Link to={"/admin/upload/0206survey/比較網頁/是否有去空曠處避難.png"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '03民眾相信的臨震保命策略與臨震反應', '圖表下載')}target="_blank"  download>下載PNG</Link></li>
							<li><Link to={"/admin/upload/0206survey/比較網頁/是否有去空曠處避難.xlsx"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '03民眾相信的臨震保命策略與臨震反應', '原始數據下載')} target="_blank" download>下載EXCEL</Link></li> 
							</CustomDropdown>
						</div>
					</div>
			</div>
		</div>

		<div className="container-c c640">
			<div className={`${(valueType[2].name === 'pdf2' || valueType === null ? ' -active' : '')} statistics-charts chat03`}>
				<img src={require("../../../images/AnalysisEarthquakeSurvey/chat03.png")} width="100%"/>
			</div>
			<div className={`${(valueType[2].name === 'Statistical2' ? ' -active' : '')} statistics-datatable2`}>
			
				<table>
					<tbody>
						<tr>
							<td colspan="5" rowspan="1">
							<p align="center">是否有去空曠處避難</p>
							</td>
						</tr>
						<tr>
							<td colspan="1" rowspan="2">
								<div>項目</div>
							</td>
							<td colspan="2" rowspan="1" align="center">臺南</td>
							<td colspan="2" rowspan="1" align="center">花蓮</td>
						</tr>
						<tr>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
						</tr>
						<tr>
							<td><p>有</p></td>
							<td><p align="right">281</p></td>
							<td><p align="right">13.3%</p></td>
							<td><p align="right">499</p></td>
							<td><p align="right">24.4%</p></td>
						</tr>
						<tr>
							<td><p>沒有</p></td>
							<td><p align="right">1828</p></td>
							<td><p align="right">86.7%</p></td>
							<td><p align="right">1550</p></td>
							<td><p align="right">75.6%</p></td>
						</tr>
						<tr>
							<td><p>總計</p></td>
							<td><p align="right">2109</p></td>
							<td><p align="right">100.0%</p></td>
							<td><p align="right">2049</p></td>
							<td><p align="right">100.0%</p></td>
						</tr>



					</tbody>
				</table>

				<br /><br /><br />

				<table>
					<tbody>
						<tr>
							<td colspan="5" rowspan="1"><p align="center">(有避難者)避難的空曠處是否為政府公告的地震避難地點</p></td>
						</tr>
					
						<tr>
							<td colspan="1" rowspan="2">
								<div>項目</div>
							</td>
							<td colspan="2" rowspan="1" align="center">臺南</td>
							<td colspan="2" rowspan="1" align="center">花蓮</td>
						</tr>
						<tr>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
						</tr>
						<tr>
							<td><p>是</p></td>
							<td><p align="right">24</p></td>
							<td><p align="right">8.6%</p></td>
							<td><p align="right">65</p></td>
							<td><p align="right">13.1%</p></td>
						</tr>
						<tr>
							<td><p>不是</p></td>
							<td><p align="right">235</p></td>
							<td><p align="right">83.6%</p></td>
							<td><p align="right">397</p></td>
							<td><p align="right">79.5%</p></td>
						</tr>
						<tr>
							<td><p>不知道/很難說</p></td>
							<td><p align="right">22</p></td>
							<td><p align="right">7.8%</p></td>
							<td><p align="right">37</p></td>
							<td><p align="right">7.3%</p></td>
						</tr>
						<tr>
							<td><p>拒答</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">1</p></td>
							<td><p align="right">0.1%</p></td>
						</tr>
						<tr>
							<td><p>總計</p></td>
							<td><p align="right">281</p></td>
							<td><p align="right">100.0%</p></td>
							<td><p align="right">499</p></td>
							<td><p align="right">100.0%</p></td>
						</tr>

					</tbody>
				</table>
				<p className="table-note">註：依母體比率進行加權，四捨五入至整數，可能產生數值誤差，如想取得調查原始數據可至0206地震網頁下方資料來源申請。</p>
				
			</div>
		</div>
		<div className="container-c c640">
			<div className="infon">
				<p>另外，兩個地震調查也顯示有九成五以上的民眾不會因這種震度而去外宿。在臺南調查中外宿者有九成是依親，其次是住在旅館或車上，雖然這次沒有調查到入住官方收容所的民眾，但依據臺南市政府的統計，當時確實有開設七處收容所，多數為活動中心及區公所，收容民眾約有202人次。花蓮調查中發現民眾外宿的處所比較多元，除六成依親以外，剩餘的安頓處所還包含學校、寺廟、教會、旅館等。</p>
			</div>
		</div>
		<div className="container-c c640">
			<div className="infon">
				<div className="title">
					<h4>地震後有沒有外宿</h4>
				</div>
			</div>
		</div>
		<div className="container-c c640">
			<div className="chart-block">
					<div className="option chart-option">

						<div className="radiobar">
							<CustomRadio className="radio" color="green" 
								group="pdf3" 
								num="3"
								
								checked={ this.state.valueType[3].name === 'pdf3' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-text">圖表</span>
								
							</CustomRadio>
							<CustomRadio className="radio" color="green" 
								group="Statistical3" 
								num="3"
								
								checked={this.state.valueType[3].name === 'Statistical3' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-tex">數據</span>
								
							</CustomRadio>
							{/* {this.state.valueType[2].name} */}
						</div>
						<div className="custom-dropdown download">
							<CustomDropdown title="下載">
							<li><Link to={"/admin/upload/0206survey/比較網頁/地震後有沒有外宿.png"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '04 地震後有沒有外宿', '圖表下載')}target="_blank" download>下載PNG</Link></li>
							<li><Link to={"/admin/upload/0206survey/比較網頁/地震後有沒有外宿.xlsx"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '04 地震後有沒有外宿', '原始數據下載')} target="_blank" download>下載EXCEL</Link></li> 
							</CustomDropdown>
						</div>
					</div>
			</div>
		</div>
		
		<div className="container-c c640">
			<div className={`${(valueType[3].name === 'pdf3' || valueType === null ? ' -active' : '')} statistics-charts chat04`}>
				<img src={require("../../../images/AnalysisEarthquakeSurvey/chat04.png")} width="100%"/>
			</div>
			<div className={`${(valueType[3].name === 'Statistical3' ? ' -active' : '')} statistics-datatable2`}>
			
				<table>
					<tbody>
						<tr>
							<td colspan="5" rowspan="1"><p align="center">地震後有沒有外宿</p></td>
						</tr>
						
						<tr>
							<td colspan="1" rowspan="2">
								<div>項目</div>
							</td>
							<td colspan="2" rowspan="1" align="center">臺南</td>
							<td colspan="2" rowspan="1" align="center">花蓮</td>
						</tr>
						<tr>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
						</tr>
						<tr>
							<td><p>有</p></td>
							<td><p align="right">36</p></td>
							<td><p align="right">1.7%</p></td>
							<td><p align="right">55</p></td>
							<td><p align="right">2.7%</p></td>
						</tr>
						<tr>
							<td><p>沒有</p></td>
							<td><p align="right">2073</p></td>
							<td><p align="right">98.3%</p></td>
							<td><p align="right">1994</p></td>
							<td><p align="right">97.3%</p></td>
						</tr>
						<tr>
							<td><p>總計</p></td>
							<td><p align="right">2109</p></td>
							<td><p align="right">100.0%</p></td>
							<td><p align="right">2049</p></td>
							<td><p align="right">100.0%</p></td>
						</tr>




					</tbody>
				</table>

				<br /><br /><br />

				<table>
					<tbody>
						<tr>
							<td colspan="5" rowspan="1"><p align="center">曾去哪些地方暫住</p></td>
						</tr>
						
						<tr>
							<td colspan="1" rowspan="2">
								<div>項目</div>
							</td>
							<td colspan="2" rowspan="1" align="center">臺南</td>
							<td colspan="2" rowspan="1" align="center">花蓮</td>
						</tr>
						<tr>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
						</tr>
						<tr>
							<td><p>親友家</p></td>
							<td><p align="right">32</p></td>
							<td><p align="right">89.7%</p></td>
							<td><p align="right">35</p></td>
							<td><p align="right">62.8%</p></td>
						</tr>
						<tr>
							<td><p>自己找的旅館</p></td>
							<td><p align="right">2</p></td>
							<td><p align="right">4.7%</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
						</tr>
						<tr>
							<td><p>住在車上</p></td>
							<td><p align="right">1</p></td>
							<td><p align="right">3.3%</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
						</tr>
						<tr>
							<td><p>公部門開設處所
								<br />（如里民活動中心、學校、體育館、軍營等）</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">5</p></td>
							<td><p align="right">9.3%</p></td>
						</tr>
						<tr>
							<td><p>其他
								<br />（如自有其他住處、付費旅館等）</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">5</p></td>
							<td><p align="right">8.8%</p></td>
						</tr>
						<tr>
							<td><p>免費旅館</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">4</p></td>
							<td><p align="right">7.9%</p></td>
						</tr>
						<tr>
							<td><p>宗教場所</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">4</p></td>
							<td><p align="right">6.5%</p></td>
						</tr>
						<tr>
							<td><p>不知道/很難說</p></td>
							<td><p align="right">1</p></td>
							<td><p align="right">2.4%</p></td>
							<td><p align="right">3</p></td>
							<td><p align="right">4.7%</p></td>
						</tr>
						<tr>
							<td><p>總計</p></td>
							<td><p align="right">36</p></td>
							<td><p align="right">100.0%</p></td>
							<td><p align="right">55</p></td>
							<td><p align="right">100.0%</p></td>
						</tr>
						
						
						
					</tbody>
				</table>
				<p className="table-note">註：依母體比率進行加權，四捨五入至整數，可能產生數值誤差，如想取得調查原始數據可至0206地震網頁下方資料來源申請。</p>
				
			</div>
			
		</div>
	</section>

	<hr></hr>

	<section id="content05">
		<div className="container-c c640">
			<div className="infon">
				<div className="title">
					<h2>花蓮調查的民眾較高比率會<br />準備防災包</h2>
				</div>
				<p>兩次的地震調查皆有詢問民眾在地震發生前與地震發生後對防災包準備的習慣是否改變，我們發現，臺南調查的民眾有七成六不論地震前或地震後都不準備防災包，花蓮調查的民眾則有約六成。顯示準備防災包並不是多數民眾會做的行為。但是花蓮調查的民眾似乎好一些，在地震發生前後皆有準備防災包者有三成，臺南調查的民眾則僅有一成三。</p>
				<p><a href="/statistics/TainanEarthquake#content13" target="_blank">看看防災包可以準備些甚麼</a></p>
				< br/>
			</div>
		</div>
		<div className="container-c c640">
			<div className="infon">
				<div className="title">
					<h4>有沒有準備防災包</h4>
				</div>
			</div>
			<div className="chart-block">
					<div className="option chart-option">

						<div className="radiobar">
							<CustomRadio className="radio" color="green" 
								group="pdf4" 
								num="4"
								
								checked={ this.state.valueType[4].name === 'pdf4' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-text">圖表</span>
								
							</CustomRadio>
							<CustomRadio className="radio" color="green" 
								group="Statistical4" 
								num="4"
								
								checked={this.state.valueType[4].name === 'Statistical4' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-tex">數據</span>
								
							</CustomRadio>
							{/* {this.state.valueType[2].name} */}
						</div>
						<div className="custom-dropdown download">
							<CustomDropdown title="下載">
							<li><Link to={"/admin/upload/0206survey/比較網頁/有沒有準備防災包.png"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '05 有沒有準備防災包', '圖表下載')} target="_blank"  download>下載PNG</Link></li>
							<li><Link to={"/admin/upload/0206survey/比較網頁/有沒有準備防災包.xlsx"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '05 有沒有準備防災包', '原始數據下載')} target="_blank" download>下載EXCEL</Link></li>
							</CustomDropdown>
						</div>
					</div>
			</div>
		</div>
		<div className="container-c c640">
			<div className={`${(valueType[4].name === 'pdf4' || valueType === null ? ' -active' : '')} statistics-charts chat05`}>
				<img src={require("../../../images/AnalysisEarthquakeSurvey/chat05.png")} width="100%"/>
			</div>
			<div className={`${(valueType[4].name === 'Statistical4' ? ' -active' : '')} statistics-datatable2`}>
			
				<table>
					<tbody>
						<tr>
							<td colspan="5" rowspan="1"><p align="center">有沒有準備防災包</p></td>
						</tr>
						<tr>
							<td colspan="1" rowspan="2">
								<div>項目</div>
							</td>
							<td colspan="2" rowspan="1" align="center">臺南</td>
							<td colspan="2" rowspan="1" align="center">花蓮</td>
						</tr>
						<tr>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
						</tr>
						<tr>
							<td><p>地震前後都有準備</p></td>
							<td><p align="right">272</p></td>
							<td><p align="right">12.9%</p></td>
							<td><p align="right">616</p></td>
							<td><p align="right">30.0%</p></td>
						</tr>
						<tr>
							<td><p>地震前後都沒有準備</p></td>
							<td><p align="right">1596</p></td>
							<td><p align="right">75.7%</p></td>
							<td><p align="right">1216</p></td>
							<td><p align="right">59.3%</p></td>
						</tr>
						<tr>
							<td><p>地震後開始準備</p></td>
							<td><p align="right">106</p></td>
							<td><p align="right">5.0%</p></td>
							<td><p align="right">110</p></td>
							<td><p align="right">5.4%</p></td>
						</tr>
						<tr>
							<td><p>地震後就沒再準備</p></td>
							<td><p align="right">127</p></td>
							<td><p align="right">6.0%</p></td>
							<td><p align="right">108</p></td>
							<td><p align="right">5.3%</p></td>
						</tr>
						<tr>
							<td><p>不知道/很難說</p></td>
							<td><p align="right">8</p></td>
							<td><p align="right">0.4%</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
						</tr>
						<tr>
							<td><p>總計</p></td>
							<td><p align="right">2109</p></td>
							<td><p align="right">100.0%</p></td>
							<td><p align="right">2049</p></td>
							<td><p align="right">100.0%</p></td>
						</tr>



					</tbody>
				</table>
				<p className="table-note">註：依母體比率進行加權，四捨五入至整數，可能產生數值誤差，如想取得調查原始數據可至0206地震網頁下方資料來源申請。</p>

			</div>

		</div>
	</section>

	<hr></hr>

	<section id="content06">	
		<div className="container-c c640">
			<div className='infon'>
				<div className="title">
					<h2>花蓮調查的民眾八成不保地震險，<br />臺南調查有五成無意願投保</h2>
					<p>臺灣的花東地區地震頻繁，東部民眾總習以為常，在地震好發情況下，民眾若能夠平時替建物加保地震保險，當建物在地震中被毀壞情況下，可獲得保險賠償、減少民眾的財產損失。但調查卻發現，花蓮調查的民眾中將近八成（78.8%）沒有保地震險，地震前後均有投保者約占14.7%，地震後才投保的比率也相當低，僅有1.6%；臺南調查的民眾當中，有投保地震險的比率也不高，僅17.3%，經歷地震後僅有16.7％民眾有意願投保地震險，但仍有五成（51.8%）的民眾無意願投保。</p>
				</div>
			</div>
		</div>
		<div className="container-c c640">
			<div className='infon'>
				<div className="title">
					<h4>投保地震險</h4>
				</div>
			</div>
			<div className="chart-block">
					<div className="option chart-option">

						<div className="radiobar">
							<CustomRadio className="radio" color="green" 
								group="pdf5" 
								num="5"
								
								checked={ this.state.valueType[5].name === 'pdf5' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-text">圖表</span>
								
							</CustomRadio>
							<CustomRadio className="radio" color="green" 
								group="Statistical5" 
								num="5"
								
								checked={this.state.valueType[5].name === 'Statistical5' ? true : false}
								onClick={ (e) => { this.handleClickRidio(e) } }>
								<span className="text type-tex">數據</span>
								
							</CustomRadio>
							{/* {this.state.valueType[2].name} */}
						</div>
						<div className="custom-dropdown download">
							<CustomDropdown title="下載">
							<li><Link to={"/admin/upload/0206survey/比較網頁/投保地震險.png"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '06 投保地震險', '圖表下載')}target="_blank"  download>下載PNG</Link></li>
							<li><Link to={"/admin/upload/0206survey/比較網頁/投保地震險.xlsx"} onClick={() => gaTracking('台南花蓮 震後調查大解析', '06 投保地震險', '原始數據下載')} target="_blank" download>下載EXCEL</Link></li> 
							</CustomDropdown>
						</div>
					</div>
			</div>
		</div>
		

		<div className="container-c c640">
			<div className={`${(valueType[5].name === 'pdf5' || valueType === null ? ' -active' : '')} statistics-charts chat06`}>
				<img src={require("../../../images/AnalysisEarthquakeSurvey/chat06.png")} width="100%"/>
			</div>
			<div className={`${(valueType[5].name === 'Statistical5' ? ' -active' : '')} statistics-datatable2`}>
			
				<table>
					<tbody>
						<tr>
							<td colspan="5" rowspan="1"><p align="center">投保地震險</p></td>
						</tr>
						<tr>
							<td colspan="1" rowspan="2">
								<div>項目</div>
							</td>
							<td colspan="2" rowspan="1" align="center">臺南</td>
							<td colspan="2" rowspan="1" align="center">花蓮</td>
						</tr>
						<tr>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
							<td><p align="right">次數分配</p></td>
							<td><p align="right">百分比</p></td>
						</tr>
						<tr>
							<td><p>地震前後沒有投保（意願）</p></td>
							<td><p align="right">1092</p></td>
							<td><p align="right">51.8%</p></td>
							<td><p align="right">1614</p></td>
							<td><p align="right">78.8%</p></td>
						</tr>
						<tr>
							<td><p>地震前後有投保</p></td>
							<td><p align="right">365</p></td>
							<td><p align="right">17.3%</p></td>
							<td><p align="right">301</p></td>
							<td><p align="right">14.7%</p></td>
						</tr>
						<tr>
							<td><p>地震後才投保（意願）</p></td>
							<td><p align="right">353</p></td>
							<td><p align="right">16.7%</p></td>
							<td><p align="right">34</p></td>
							<td><p align="right">1.6%</p></td>
						</tr>
						<tr>
							<td><p>不知道/很難說</p></td>
							<td><p align="right">299</p></td>
							<td><p align="right">14.2%</p></td>
							<td><p align="right">98</p></td>
							<td><p align="right">4.8%</p></td>
						</tr>
						<tr>
							<td><p>拒答</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">-</p></td>
							<td><p align="right">2</p></td>
							<td><p align="right">0.1%</p></td>
						</tr>
						<tr>
							<td><p>總計</p></td>
							<td><p align="right">2109</p></td>
							<td><p align="right">100.0%</p></td>
							<td><p align="right">2049</p></td>
							<td><p align="right">100.0%</p></td>
						</tr>



					</tbody>
				</table>
				<p className="table-note">註：依母體比率進行加權，四捨五入至整數，可能產生數值誤差，如想取得調查原始數據可至0206地震網頁下方資料來源申請。</p>

			</div>

		</div>
			
		
	
	</section>

	<section className="svi-section svi-articlelist">
		<div className="container">
			<h2 className="sectiontitle">你可能會想看</h2>
		
			<div className="row subject-list">
				<div className="col-lg-6">
					<div className="article-item">
						<Link to="/statistics/TainanEarthquake" className="image -black">
							<img src={require("../../../images/TainanEarthquake/1201.jpg")} width="100%"/>
						</Link>						
						<div className="content">
							<Link to="/statistics/TainanEarthquake" className="title">0206臺南震災天然災害社經影響家戶調查(2016)</Link>							
						</div>
					</div>
				</div>
				<div className="col-lg-6">
					<div className="article-item">
						<Link to="/statistics/HualienEarthquake" className="image -black">
							<img src={require("../../../images/HualienEarthquake/1201.jpg")} width="100%"/>
						</Link>
						<div className="content">
							<Link to="/statistics/HualienEarthquake" className="title">0206花蓮震災地震感知與避難行為調查(2018)</Link>							
						</div>
					</div>
				</div>
			</div>

		</div>
	</section>


			</div>
		);
	}
}

export default AnalysisEarthquakeSurveyIndex;
